module.exports = __webpack_public_path__ + "images/d871410e868929a07ceb0542df78eea0.svg";